<script setup lang="ts">
import { useRoute } from 'vue-router';
import TextTabItem from '@/components/common/molecules/text-tab-item.vue';

const route = useRoute();
const tabs = [
  {
    name: '相手から共有',
    linkTo: {
      name: 'sharedByOthers',
    },
  },
  {
    name: '自分が共有',
    linkTo: {
      name: 'sharedByMe',
    },
  },
  {
    name: '未共有',
    linkTo: {
      name: 'notShared',
    },
  },
];
</script>

<template>
  <div class="header-title">
    <div class="header-content">
      <div class="c-title-bold--l">シェアスレッド</div>
    </div>
  </div>
  <div class="header-tabs">
    <div class="header-content tabs">
      <router-link
        v-for="tab in tabs"
        :key="tab.name"
        class="c-title-bold--m"
        :to="tab.linkTo"
      >
        <TextTabItem
          :text="tab.name"
          :is-selected="route.name === tab.linkTo.name"
        />
      </router-link>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.header-title {
  padding: 16px 24px;
  display: flex;
  justify-content: center;
  border-bottom: 1px solid $color-gray400;
  background-color: $color-white;
}
.header-tabs {
  display: flex;
  justify-content: center;
  background-color: $color-white;
}
.header-content {
  max-width: var(--survey-session-width);
  width: 100%;
}
.tabs {
  display: flex;
}
</style>
